// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P1Mm","controls":"styles_controls__1-51c","charLimit":"styles_charLimit__dGFC5","input":"styles_input__19SKf","send":"styles_send__10yE7"};